import { Routes, Route } from 'react-router-dom';
import AssetLinksComponent from './screens/asset';
import IosAssetLinksComponent from './screens/iosasset';
import App from './App';
import Product from './Product';
import PrivacyPolicy from './screens/privacypolicy';
import Support from './screens/support';
import Terms from './screens/terms';
import Delete from './screens/delete';
import Checkout from './Checkout';
import RefundPolicy from './screens/refundpolicy';
import Confirm from './Confirm';

import UAEApp from './regional/uae/App';
import UAEProduct from './regional/uae/Product';
import UAECheckout from './regional/uae/Checkout';
import UAEConfirm from './regional/uae/Confirm';
import UAEPrivacyPolicy from './regional/uae/screens/privacypolicy';
import UAERefundPolicy from './regional/uae/screens/refundpolicy';
import UAETerms from './regional/uae/screens/terms';
import UAESupport from './regional/uae/screens/support';
import UAEDelete from './regional/uae/screens/delete';
import UAEMarquee from './regional/uae/UAEMarquee';

const currentUrl = window.location.href;
let showMarquee: boolean = false;
if (currentUrl.includes('uae')) {
  showMarquee = true;
} else {
  showMarquee = false;
}

const AllRoutes = () => {
  return (
    <div className="overflow-x-hidden">
      <UAEMarquee showMarquee={showMarquee} speed="slow" />

      <main className="min-h-screen">
        <Routes>
          {/* Global routes */}
          <Route path="/" element={<App />} />
          <Route path="/product" element={<Product />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirm" element={<Confirm />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/user-support" element={<Support />} />
          <Route path="/delete-my-account" element={<Delete />} />

          {/* Well-known routes for app associations */}
          <Route
            path="/.well-known/apple-app-site-association"
            element={<IosAssetLinksComponent />}
          />
          <Route
            path="/.well-known/assetlinks.json"
            element={<AssetLinksComponent />}
          />

          {/* UAE-specific routes */}
          <Route path="/uae">
            <Route index element={<UAEApp />} />
            <Route path="product" element={<UAEProduct />} />
            <Route path="checkout" element={<UAECheckout />} />
            <Route path="confirm" element={<UAEConfirm />} />
            <Route path="privacy-policy" element={<UAEPrivacyPolicy />} />
            <Route path="refund-policy" element={<UAERefundPolicy />} />
            <Route path="terms-and-conditions" element={<UAETerms />} />
            <Route path="user-support" element={<UAESupport />} />
            <Route path="delete-my-account" element={<UAEDelete />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
};

export default AllRoutes;
